<template>
    <div class="upgrade-show-information">
        <div class="small-container">
            <div class="step-title">
                Confirm Your Show Details
            </div>

            <div class="step-description">
                We only need the title of your podcast to get started. You can change this anytime in the <i>Settings</i> page.
            </div>
        </div>

        <div class="big-container">
            <base-show-information-form
                :show="show"
                @submit="$emit('submit')"
            />
        </div>
    </div>
</template>
<script>
import BaseShowInformationForm from '@/components/Shows/BaseShowInformationForm';

export default {
    components: {
        BaseShowInformationForm,
    },

    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
    },
};
</script>
